import React from 'react';
import { FlatButton } from 'material-ui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const ActionButton = (props) => {
  const {
    dispatchAction,
    actionArgs,
    children = null,
    Component,
  } = props;

  const restProps = _.omit(props, ['dispatchAction', 'actionArgs', 'action', 'children', 'Component']);

  return (
    <Component {...restProps} onClick={() => dispatchAction(...actionArgs)}>
      { children }
    </Component>
  );
};

ActionButton.propTypes = {
  actionArgs: PropTypes.arrayOf(PropTypes.any),
  dispatchAction: PropTypes.func,
  children: PropTypes.node,
  Component: PropTypes.func,
};

ActionButton.defaultProps = {
  actionArgs: [],
  Component: FlatButton,
};

const dispatchToProps = (dispatch, { action }) =>
  ({ dispatchAction: (...args) => dispatch(action(...args)) });

export default connect(null, dispatchToProps)(ActionButton);



// WEBPACK FOOTER //
// ./src/components/ActionButton.js